<template>

  <div class="post-content-image">
      <img :src="data.value"/>
      <button class="btn btn-sm btn-danger item-delete" @click="$emit('remove', index)" ><i class="ti-trash"></i> </button>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      default: null,
    },
    data: {
      default: null,
    },
  },
  methods: {

  },
  data: () => ({
    value: ''
  }),
};
</script>
